export default __webpack_public_path__ + "static/media/thought-catalog-505eectW54k-unsplash.d2e27a47.jpg";